import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledWrapper = styled.div`
  display: flex;
  height: 30px;
  margin-top: -5px;
  justify-content: space-between;
  align-items: center;
`

const FilterAndSearchRow = ({ children, className }) => {
  return (
    <StyledWrapper className={className}>
      {children}
    </StyledWrapper>
  )
}

FilterAndSearchRow.propTypes = {
  children: PropTypes.node,
}

export default FilterAndSearchRow
